import styles from './FAQ.module.scss'

interface FAQList {
  questionText: string
  answerText: string
}

const FAQLists: FAQList[] = [
  {
    questionText: 'バックエンド開発だけでなくデザインもお願いできますか？',
    answerText:
      '当社ではUIデザインから開発をシームレスに繋ぐところに強みを持っています。また開発工程を考慮したデザインが設計ができるのも当社の大きな特徴です。',
  },
  {
    questionText: 'サーバー環境の構築・運用もお願いできますか？',
    answerText:
      'AWS テクノロジーパートナーとして登録されており運用について豊富な実績があります。安心してお任せください。',
  },
  {
    questionText: 'まだ仕様が固まっていません。。。',
    answerText:
      'バックエンド開発だけでなくサービス開発やUI設計も得意としております。ご予算に応じて上流工程から参画も可能です。',
  },
  {
    questionText: '依頼したい同種のサービスの過去実績を知りたい。',
    answerText:
      'B2C向けアプリ、管理画面、マイページ、ウェブサービスなど掲載されている以外にも豊富な過去実績がございます。詳細はお問い合わせ時にご案内させていただきます。',
  },
]

const FAQ: React.VFC = () => {
  const FAQList = FAQLists.map(({ questionText, answerText }) => (
    <li className={styles.li} key={questionText}>
      <div className={styles.FAQWrapper}>
        <div className={styles.questionWrapper}>
          <p className={styles.question}>Q</p>
          <p className={styles.questionText}>{questionText}</p>
        </div>
        <div className={styles.answerWrapper}>
          <p className={styles.answer}>A</p>
          <p className={styles.answerText}>{answerText}</p>
        </div>
      </div>
    </li>
  ))
  return (
    <section className={styles.FAQ} id="FAQ">
      <div className={styles.wrapper}>
        <p className={styles.title}>よくある質問</p>
        <ul className={styles.FAQList}>{FAQList}</ul>
      </div>
    </section>
  )
}

export default FAQ
